import React, { useCallback, useMemo, useState, createContext, useContext } from 'react';
export const BASE_PRICE = 15;
export const ORDER_BUMP_PRICE = 5;
export type OrderBumpId = 'kit-emergencia' | 'lista-super';
// Shopify permalink variants per selected order-bump combination.
const CHECKOUT_URLS = {
  base: 'https://www.legadosalud.com/cart/42499535011925:1',
  kitOnly: 'https://www.legadosalud.com/cart/42540143149141:1',
  listaOnly: 'https://www.legadosalud.com/cart/42540160745557:1',
  both: 'https://www.legadosalud.com/cart/42540157010005:1'
} as const;
interface OrderContextValue {
  selected: Record<string, boolean>;
  toggle: (id: OrderBumpId | string) => void;
  isSelected: (id: OrderBumpId | string) => boolean;
  selectedCount: number;
  total: number;
  formattedTotal: string;
  ctaLabel: string;
  checkoutUrl: string;
}
const OrderContext = createContext<OrderContextValue | null>(null);
function formatPrice(value: number): string {
  // Show one decimal only when needed (e.g. $17.5, $22.5, but $20)
  const fixed = value.toFixed(2);
  // Strip trailing zero(s) — but keep one decimal if it's not whole, e.g. 17.50 -> 17.5, 20.00 -> 20
  return fixed.replace(/\.?0+$/, '');
}
export function OrderProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [selected, setSelected] = useState<Record<string, boolean>>({});
  const toggle = useCallback((id: string) => {
    setSelected(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  }, []);
  const isSelected = useCallback((id: string) => !!selected[id], [selected]);
  const kit = !!selected['kit-emergencia'];
  const lista = !!selected['lista-super'];
  const selectedCount = (kit ? 1 : 0) + (lista ? 1 : 0);
  const total = BASE_PRICE + selectedCount * ORDER_BUMP_PRICE;
  const formattedTotal = `${formatPrice(total)} USD`;
  const ctaLabel = `Descárgalo Ahora Por ${formattedTotal}`;
  const checkoutUrl = kit && lista ? CHECKOUT_URLS.both : kit ? CHECKOUT_URLS.kitOnly : lista ? CHECKOUT_URLS.listaOnly : CHECKOUT_URLS.base;
  const value: OrderContextValue = {
    selected,
    toggle,
    isSelected,
    selectedCount,
    total,
    formattedTotal,
    ctaLabel,
    checkoutUrl
  };
  return <OrderContext.Provider value={value} data-id="element-265">{children}</OrderContext.Provider>;
}
export function useOrder(): OrderContextValue {
  const ctx = useContext(OrderContext);
  if (!ctx) {
    throw new Error('useOrder must be used within an OrderProvider');
  }
  return ctx;
}